import React, { Component } from 'react';

import './polaroid-with-pin-gallery.css'; 

export class PolaroidWithPinGallery extends Component {

    render() {
        const {photos} = this.props

        return (
            <main className="acsw-polaroid-with-pin-gallery-content">
            <section className="galery">
                <div className="galery__acsw-polaroid-with-pin-gallery-content" >
                {photos.map((photo, i) => {
                            return (
                                <div key={i} className="img"><img src={photo.src} alt="" /></div>
                        )   
                        }
                    )}
                </div>
            </section>
            </main>)
        
    }
}


// WEBPACK FOOTER //
// ./src/components/Galleries/PolaroidWithPinGallery/index.js